// Types
import * as Types from '../types'
import {requestActionProps, requestGenerate} from '../../common'
import api from '../../../services/api'
import {callbackProps, ID, IHomework} from '../../../constants'
import { SET_TASK_COMPLETED } from '../../onboarding/actions';
import { store } from '../../ROOT/store';
import * as fbq from "../../../utils/FacebookPixel";

const actionGetHomeworks = (
  payload: any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.REQUEST),
  api: api.getHomeworks,
  payload: {data: new URLSearchParams(payload)},
  callback,
})

const actionGetHomeworkById = (
  payload: {id: ID},
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  payload: {data: payload},
  type: requestGenerate(Types.REQUEST),
  api: api.getHomeworkById,
  callback,
})

const actionCreateHomework = (
  payload: IHomework,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  payload: {data: payload},
  type: requestGenerate(Types.REQUEST),
  api: api.createHomework,
  callback: (response: any) => {
    if (response.type === 'SUCCESS' && response.payload?.status === true) {
      store.dispatch({ type: SET_TASK_COMPLETED, payload: 'assignmentsCreated', value: true });
      window.lintrk?.('track', { conversion_id: 21977513 });
      fbq.event('FirstHomeWorkAdded', {
        content_name: 'First Homework Added',
        content_category: 'Onboarding',
      });
    }
    callback?.(response);
  }
})

const actionUpdateHomework = (
  payload: IHomework,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  payload: {data: payload},
  type: requestGenerate(Types.REQUEST),
  api: api.updateHomework,
  callback,
})

const actionDeleteHomework = (
  payload: {id: ID},
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.REQUEST),
  api: api.deleteHomework,
  payload: {data: payload},
  callback,
})

export {
  actionGetHomeworkById,
  actionDeleteHomework,
  actionUpdateHomework,
  actionGetHomeworks,
  actionCreateHomework,
}
